import type { RouteRecordRaw } from 'vue-router';

export default {
  path: '/security',
  name: 'security',
  component: () => import('@/views/dashboard/security/security.vue'),
} satisfies RouteRecordRaw;
